import { joinWithSpaces } from 'utils/stringHelpers';
import { ExpressionSerializer } from '../../expression/serializer';
import { HashSerializer } from '../../hash/serializer';
import { StatementWithArgs } from '../types';

export class StatementArgsSerializer {
  static serialize = (statement: Pick<StatementWithArgs, 'hash' | 'params'>) =>
    joinWithSpaces([
      StatementArgsSerializer.serializeStatementParams(statement.params),
      statement.hash ? HashSerializer.serialize(statement.hash) : '',
    ]);

  private static serializeStatementParams = (params: StatementWithArgs['params']) =>
    joinWithSpaces(params.map(ExpressionSerializer.serialize));
}
